import { cn } from '@/lib/utils.ts';

type Props = {
  className?: string;
};

export default function Hr({ className }: Props) {
  return <hr className={cn('my-6 border-hydrangea-100', className)} />;
}
